"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.Channels = void 0;
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var helpers_1 = require("./helpers");
var Items = function (_a) {
    var active = _a.active, user = _a.user;
    var permissions = user.permissions;
    return react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-items' }, helpers_1.items.map(function (item) {
        return item.items
            .filter(function (item) { return item.main && permissions.includes(item.permission); })
            .map(function (item) {
            return react_1.default.createElement(storybook_1.Menus.Dashboard.Item, { to: item.url, key: item.name, active: active === item.name }, item.label);
        });
    }));
};
var Brand = function () { return react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-brand' },
    react_1.default.createElement(storybook_1.Menus.Dashboard.Logo, null)); };
var Channels = function (_a) {
    var channel = _a.channel, channels = _a.channels, setChannel = _a.setChannel, setDropdown = _a.setDropdown, dropdown = _a.dropdown;
    var _b = react_1.useState(), search = _b[0], setSearch = _b[1];
    return react_1.default.createElement(storybook_1.Dropdowns.Container, { open: dropdown, onClose: function () { return setDropdown(!dropdown); } },
        react_1.default.createElement("input", { type: 'text', className: 'w-full px-4 py-2 outline-none text-sm border-b border-solid border-gray-300', placeholder: 'Zoeken...', value: search, onChange: function (e) { return setSearch(e.target.value); }, autoFocus: true }),
        channels
            .filter(function (channel_record) { return !search
            || channel_record.label.toLowerCase().includes(search.toLowerCase()); })
            .map(function (channel_record, index) {
            return react_1.default.createElement(storybook_1.Dropdowns.LinkButton, { key: index, onClick: function () {
                    setChannel(channel_record);
                    setDropdown(!dropdown);
                    setSearch('');
                } },
                react_1.default.createElement(storybook_1.Menus.Dashboard.Avatar, { image: channel_record.logo, size: 'sm' }),
                channel_record.label,
                channel_record.id === channel.id &&
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: 'check', className: 'storybook-menus-dashboard-header-dropdown-icon' }));
        }));
};
exports.Channels = Channels;
var BottomDefault = function (_a) {
    var user = _a.user, active = _a.active, channel = _a.channel, setChannel = _a.setChannel, button = _a.button;
    var _b = react_1.useState(false), dropdown = _b[0], setDropdown = _b[1];
    var channels = ra_fetch_1.useApi('backend').index('user.channels', { id: user.id, sort: 'name asc' })[0];
    channel = channels.data.findBy('id', channel.id) || channel;
    if (channels.data.loading || !channels.data.length) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("header", { className: 'storybook-menus-dashboard-header-bottom' },
        react_1.default.createElement(storybook_1.Layouts.Container, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(storybook_1.Menus.Dashboard.Label, null, helpers_1.getActivePage(active).label),
                Boolean(channels.data.length) &&
                    react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-dropdown' },
                        react_1.default.createElement(storybook_1.Buttons.Button, { className: 'storybook-menus-dashboard-header-button', onClick: function () { return setDropdown(!dropdown); } },
                            react_1.default.createElement(storybook_1.Menus.Dashboard.Title, null, channel.label || 'Kies een kanaal'),
                            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'chevron-down', className: 'w-8 h-8' })),
                        react_1.default.createElement(exports.Channels, { channel: channel, channels: channels.data, setChannel: setChannel, dropdown: dropdown, setDropdown: setDropdown }))),
            react_1.default.createElement(BottomCallToAction, { user: user, button: button })));
};
var BottomReturnUrl = function (_a) {
    var user = _a.user, active = _a.active, button = _a.button, returnUrl = _a.returnUrl;
    return (react_1.default.createElement("header", { className: 'storybook-menus-dashboard-header-bottom' },
        react_1.default.createElement(storybook_1.Layouts.Container, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(storybook_1.Menus.Dashboard.Label, null, helpers_1.getActivePage(active).label),
                react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-dropdown' },
                    react_1.default.createElement(storybook_1.Buttons.Link, { className: 'storybook-menus-dashboard-header-button', to: "" + process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + returnUrl },
                        react_1.default.createElement(storybook_1.Icons.Icon, { name: 'chevron-left', className: 'w-8 h-8' }),
                        react_1.default.createElement(storybook_1.Menus.Dashboard.Title, null, "Terug")))),
            react_1.default.createElement(BottomCallToAction, { user: user, button: button }))));
};
var BottomCallToAction = function (_a) {
    var user = _a.user, button = _a.button;
    if (!button.to || !user.permissions.includes(button.permission)) {
        return null;
    }
    return react_1.default.createElement("div", null,
        react_1.default.createElement(storybook_1.Buttons.Link, { className: 'storybook-menus-dashboard-header-mobile-calltoaction', to: button.to, type: 'primary', icon: button.icon }, button.title));
};
var Header = function (_a) {
    var active = _a.active, user = _a.user, channel = _a.channel, setChannel = _a.setChannel, button = _a.button, returnUrl = _a.returnUrl;
    return react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header' },
        react_1.default.createElement("nav", { className: 'storybook-menus-dashboard-nav' },
            react_1.default.createElement(storybook_1.Layouts.Container, null,
                react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-top' },
                    react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-top-left' },
                        Boolean(channel.id) && channel.type !== 'player' &&
                            react_1.default.createElement(storybook_1.Menus.Dashboard.Sidebar, { user: user, channel: channel, items: helpers_1.items }),
                        react_1.default.createElement(Brand, null),
                        react_1.default.createElement(Items, { active: active, user: user })),
                    react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-top-right' },
                        react_1.default.createElement(storybook_1.Menus.Dashboard.Profile, { user: user }))))),
        returnUrl
            ? react_1.default.createElement(BottomReturnUrl, { user: user, active: active, button: button, returnUrl: returnUrl })
            : react_1.default.createElement(BottomDefault, { user: user, active: active, channel: channel, setChannel: setChannel, button: button }));
};
exports.Header = Header;
exports.Header.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number,
        permissions: prop_types_1.default.array,
    }),
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number,
    }),
    /**
     * Set current channel
     */
    setChannel: prop_types_1.default.func,
    /**
     * Active page slug
     */
    active: prop_types_1.default.string,
    /**
     * Current user session
     */
    button: prop_types_1.default.shape({
        to: prop_types_1.default.string,
        icon: prop_types_1.default.string,
        title: prop_types_1.default.string,
        permission: prop_types_1.default.string,
    }),
    /**
     * Return url back button
     */
    returnUrl: prop_types_1.default.string,
};
exports.Header.defaultProps = {
    button: {},
};
